var _style, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0 {\n\t  fill-rule: evenodd;\n\t  clip-rule: evenodd;\n\t  fill: #ffffff;\n\t}\n\t.st1 {\n\t  fill-rule: evenodd;\n\t  clip-rule: evenodd;\n\t  fill: #bf1212;\n\t}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.4,7.7c5.9-6,16.8-7,28.5-7.1c11.6,0.1,22.6,1.2,28.5,7.1c6,5.9,7,16.8,7.1,28.5c-0.1,11.6-1.2,22.6-7.1,28.5  c-5.9,5.9-16.8,7-28.5,7.1c-11.6-0.1-22.6-1.2-28.5-7.1c-6-5.9-7-16.8-7.1-28.5C0.4,24.5,1.4,13.5,7.4,7.7L7.4,7.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.4,64.6c-5.2-5.2-6.7-14.3-7-24.4h14.9l3.1-7.4H0.4c0-1.1,0.1-2.3,0.1-3.4h19.4L23,22H1.2  c0.2-1.1,0.4-2.3,0.6-3.4h22.5l3.2-7.4H4.7c0.8-1.3,1.7-2.5,2.7-3.6c5.9-6,16.8-7,28.5-7.1c11.6,0.1,22.6,1.2,28.5,7.1  c4.9,4.8,6.5,13.1,6.9,22.3H58.2L55,37.4h16.4c0,1.1-0.1,2.2-0.1,3.4H53.6l-3.1,7.4h20.3c-0.1,1.2-0.3,2.3-0.5,3.4H49L45.9,59h22.2  c-0.9,2.2-2.2,4.1-3.8,5.6c-5.9,6-16.8,7-28.5,7.1C24.2,71.6,13.3,70.6,7.4,64.6z M37.6,63.1l16.3-37.6c0.7-1.6-1.5-3.1-3.3-2.3  l-16.7,7.9L39,9.6c0.5-2.2-3.5-3.2-4.4-1L19.4,45c-0.7,1.7,1.6,3.1,3.4,2.2l16-8.2L33.3,62C32.8,64.3,36.7,65.2,37.6,63.1z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShock);
export default __webpack_public_path__ + "static/media/shock.332d8443e2c6b968619ac60d2f0185bd.svg";
export { ForwardRef as ReactComponent };